import createSelector from 'lib/web/createSelector'
import config from 'constants/config'

const regionsWithLastMinute = ['AU', 'NZ']

export const isLastMinuteEnabled = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (currentRegionCode) => !!(config.LAST_MINUTE_ENABLED && regionsWithLastMinute.includes(currentRegionCode)),
)
